import { render, staticRenderFns } from "./Basket.vue?vue&type=template&id=9f71dd1c&scoped=true&"
import script from "./Basket.vue?vue&type=script&lang=js&"
export * from "./Basket.vue?vue&type=script&lang=js&"
import style0 from "./Basket.vue?vue&type=style&index=0&id=9f71dd1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f71dd1c",
  null
  
)

export default component.exports